import React from 'react';
import styled, { keyframes } from 'styled-components';
import { CSSTransitionGroup } from 'react-transition-group';

export default class Spinner extends React.Component {

    constructor(props) {
        super(props);


        const fadeIn = keyframes`
            from {
              opacity: 0;
              transform: translate3d(0, 10%, 0);
            }
            to {
              opacity: 1;
              transform: none;
            }
        `;


        const sk_rotate = keyframes`
            100% {
                transform: rotate(360deg)
            }
        `;

        const sk_bounce = keyframes`
            0%, 100% {
                transform: scale(0.0);
            } 50% {
                transform: scale(1.0);
            }
        `;




        this.Container = styled.div `
            font-family: 'Helvetica', sans-serif;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(26, 29, 36, 0.3);
            color: #fff;
            z-index: 10;
            text-align: center;
            .block{
                animation: ${fadeIn} 0.5s 0s both;
                margin: 14% 20%;
                font-size: 32px;
                text-shadow: 0 4px 2px rgba(0,0,0,0.2);
            }
            .spinner {
              margin: 100px auto;
              width: 60px;
              height: 60px;
              position: relative;
              text-align: center;
              animation: ${sk_rotate} 2.0s infinite linear;
            }

            .dot1, .dot2 {
              width: 60%;
              height: 60%;
              display: inline-block;
              position: absolute;
              top: 0;
              background-color: #fff;
              border-radius: 100%;
              animation: ${sk_bounce} 2.0s infinite ease-in-out;
            }

            .dot2 {
              top: auto;
              bottom: 0;
              animation-delay: -1.0s;
            }

        `;
    }

    render() {
        return (
            <this.Container>
                <CSSTransitionGroup
                    transitionName={`fadeIn`}
                    transitionAppear={true}
                    transitionLeave={false}
                    transitionEnter={false}
                    transitionAppearTimeout={ 1000 }>
                    <div className="block">
                        <div>
                            <div className="spinner">
                              <div className="dot1"></div>
                              <div className="dot2"></div>
                            </div>
                        </div>
                        <p>
                            { this.props.text }
                        </p>
                    </div>
                </CSSTransitionGroup>
            </this.Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/base/Spinner.js